import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import settingsFaqsService from '../../services/settingsFaqs';

const initialState = {
  loading: false,
  faqs: [],
  error: '',
  saveStatusById: {},
};

export const fetchFaqs = createAsyncThunk('faq/fetchFaqs', (params = {}) =>
  settingsFaqsService.getAll(params).then((res) => res),
);

export const createFaq = createAsyncThunk(
  'faq/createFaq',
  ({ payload, file } = {}) =>
    settingsFaqsService.create(payload, file).then((res) => res),
);

export const updateFaq = createAsyncThunk(
  'faq/updateFaq',
  ({ id, payload, file } = {}) =>
    settingsFaqsService.update(id, payload, file).then((res) => res),
);

export const deleteFaq = createAsyncThunk('faq/deleteFaq', (id) =>
  settingsFaqsService.delete(id).then((res) => res),
);

export const persistFaqDisplayOrder = createAsyncThunk(
  'faq/persistFaqDisplayOrder',
  ({ id, displayOrder } = {}) =>
    settingsFaqsService
      .update(id, { displayOrder })
      .then((res) => ({ res, id })),
);

const faqSlice = createSlice({
  name: 'faq',
  initialState,
  reducers: {
    applyOptimisticOrder(state, action) {
      state.faqs = action.payload;
    },
    clearRowSaveStatus(state, action) {
      const id = action.payload;
      if (id) {
        delete state.saveStatusById[id];
      } else {
        state.saveStatusById = {};
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchFaqs.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchFaqs.fulfilled, (state, action) => {
      const { payload } = action;
      state.loading = false;
      const data = payload?.data ?? payload;
      const list =
        (Array.isArray(data) && data) ||
        (Array.isArray(data?.data) && data.data) ||
        (Array.isArray(data?.faqs) && data.faqs) ||
        (Array.isArray(payload?.faqs) && payload.faqs) ||
        [];
      state.faqs = list;
      state.error = '';
    });
    builder.addCase(fetchFaqs.rejected, (state, action) => {
      state.loading = false;
      state.faqs = [];
      state.error = action.error.message;
    });

    builder.addCase(persistFaqDisplayOrder.pending, (state, action) => {
      const id = action.meta?.arg?.id;
      if (id) state.saveStatusById[id] = 'saving';
    });
    builder.addCase(persistFaqDisplayOrder.fulfilled, (state, action) => {
      const id = action.payload?.id;
      if (id) state.saveStatusById[id] = 'saved';
    });
    builder.addCase(persistFaqDisplayOrder.rejected, (state, action) => {
      const id = action.meta?.arg?.id;
      if (id) state.saveStatusById[id] = 'failed';
    });
  },
});

export const { applyOptimisticOrder, clearRowSaveStatus } = faqSlice.actions;
export default faqSlice.reducer;
